'use client';
/* eslint-disable */

import {
   Box,
   Button,
   Flex,
   IconButton,
   Table,
   Tbody,
   Td,
   Text,
   Th,
   Thead,
   Tr,
   useColorModeValue,
   useDisclosure,
   Select,
   Grid,
   useOutsideClick,
} from '@chakra-ui/react';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import {
   createColumnHelper,
   flexRender,
   getCoreRowModel,
   getSortedRowModel,
   useReactTable,
} from '@tanstack/react-table';
import 'jspdf-autotable';
import React, { useCallback, useEffect, useState, useRef } from 'react';
import Card from 'components/card/Card';
import Menu from 'components/menu/MainMenu';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import { useDispatch, useSelector } from 'react-redux';
import DeleteDialog from '../../../masters/components/DeleteDialog';
import { downloadPDF, downloadExcel, useServerPagination } from '../../../../../utils/DataTableUtils';
import {
   getSaleInvoices,
   deleteSaleInvoice,
   getSingleSaleInvoice,
   emptySales,
} from '../../../../../redux/actions/salesInvoice';
import { getAccount, getAccountById } from '../../../../../redux/actions/account';
import { getDaybook } from '../../../../../redux/actions/daybook';
// import { getBillTerm } from '../../../../../redux/actions/billTerm';
// import { getCompanies } from '../../../../../redux/actions/company';
import { getItem } from '../../../../../redux/actions/item';
import { useNavigate } from 'react-router-dom';
import Loading from 'components/loading/Loading';
import SalesSingleDataView from './SaleSingleDataView';
import moment from 'moment';
import { ACCOUNT_TYPE } from '../../../../../constants/index';
import { MdNavigateNext, MdNavigateBefore } from 'react-icons/md';
import { SearchIcon } from '@chakra-ui/icons';
import { motion } from 'framer-motion';

// filter
import filter from 'assets/img/nfts/filter.svg';
import filter1 from 'assets/img/nfts/filter1.svg';
import nodata from 'assets/img/nfts/no data.svg';
import { GridItem, Input, FormLabel } from '@chakra-ui/react';
import { useUser } from '../../../../../contexts';
//filter end

const columnHelper = createColumnHelper();
const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

export default function SalesInvoiceMaster() {
   const [sorting, setSorting] = React.useState([]);
   const dispatch = useDispatch();
   const salesInvoiceData = useSelector((state) => state.sales.list || []);
   const totalCount = useSelector((state) => state.sales.totalCount);
   const isLoading = useSelector((state) => state.sales.isLoading);
   const pagination = useSelector((state) => state.sales?.pagination);
   const [data, setData] = React.useState([...salesInvoiceData]);
   const [currentRow, setCurrentRow] = React.useState(null);
   const [searchQuery, setSearchQuery] = React.useState('');
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false); // State to manage delete confirmation
   const [selectedRowId, setSelectedRowId] = React.useState(null);
   const [isEditMode, setIsEditMode] = React.useState(false);
   const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
   const [editingRow, setEditingRow] = React.useState(null);
   const [isOpenSingleView, setIsOpenSingleView] = React.useState(false);
   const singleEntity = useSelector((state) => state?.sales?.single || {});
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const [initialIndex, setInitialIndex] = useState(0);
   const { user } = useUser();

   const [currentPage, setCurrentPage] = useState(1);
   const [limit, setLimit] = useState(10);

   const navigate = useNavigate();

   // Use the server pagination hook
   const { resetPage, totalPages, pageSize, getPaginationParams } = useServerPagination(totalCount);

   useEffect(() => {
      setCurrentPage(1); // Reset to page 1 whenever searchQuery changes
   }, [searchQuery]);

   const getSaleInvoice = useCallback(async () => {
      if (user && user?.loginhistory?.companyId) {
         await dispatch(
            getSaleInvoices({
               page: currentPage,
               limit: limit === pagination?.totalProducts ? undefined : limit, // undefined fetches everything
               companyId: user?.loginhistory?.companyId,
               search: searchQuery,
               sortBy: sorting.length ? sorting[0]?.id : 'id',
               sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
            }),
         );
      }
   }, [dispatch, currentPage, limit, searchQuery, sorting, user]);

   useEffect(() => {
      getSaleInvoice();
   }, [getSaleInvoice]);

   const handlePageChange = (direction) => {
      const newPage = direction === 'next' ? pagination.nextPage : pagination.previousPage;
      if (newPage) setCurrentPage(newPage);
   };

   const handlePageSizeChange = (e) => {
      const value = e.target.value;

      // If "ALL" is selected, set limit to null or totalProducts to fetch everything
      const newLimit = value === 'ALL' ? pagination?.totalProducts : Number(value);

      setLimit(newLimit);
      setCurrentPage(1); // Reset to page 1 to avoid offset issues
   };

   useEffect(() => {
      dispatch(getAccount({ type: ACCOUNT_TYPE.CUSTOMER, compId: user?.loginhistory?.companyId, status: true }));
      if (user && user?.loginhistory?.companyId)
         dispatch(getDaybook({ companyId: user?.loginhistory?.companyId }));
      // dispatch(getBillTerm());
      // dispatch(getCompanies());
      dispatch(getItem({ companyId: user.loginhistory.companyId }));
   }, [dispatch, ACCOUNT_TYPE.CUSTOMER]);

   // useEffect(() => {
   //   setData([...salesInvoiceData]);
   // }, [salesInvoiceData]);

   const handleDelete = async () => {
      if (selectedRowId !== null) {
         try {
            await dispatch(deleteSaleInvoice(selectedRowId));
            dispatch(
               getSaleInvoices({
                  page: currentPage,
                  limit: limit,
                  companyId: user?.loginhistory?.companyId,
                  search: searchQuery,
               }),
            );
            setData(data.filter((row) => row.id !== selectedRowId));
            setDeleteDialogOpen(false); // Close the dialog after deletion
         } catch (err) {
            // console.error("Failed to delete Color:", err);
         }
      }
   };

   const handleDeleteClick = (id) => {
      setSelectedRowId(id);
      setDeleteDialogOpen(true);
   };
   const columnsData = [
      { id: 'docno', header: 'DOC NO', accessor: 'docno' },
      {
         id: 'transactionAt',
         header: 'Bill Date',
         accessor: 'transactionAt',
      },
      { id: 'daybookname', header: 'Daybook', accessor: 'daybookname' },
      { id: 'accountname', header: 'Party', accessor: 'accountname' },
      { id: 'qty1', header: 'Qty 1', accessor: 'qty1' },
      { id: 'qty2', header: 'Qty 2', accessor: 'qty2' },
      { id: 'qty3', header: 'Qty 3', accessor: 'qty3' },
      {
         id: 'taxableAmount',
         header: 'Taxable Amount',
         accessor: 'taxableAmount',
      },
      {
         id: 'gstAmount',
         header: 'GST',
         accessor: 'gstAmount',
      },
      { id: 'netAmount', header: 'Net Amount', accessor: 'netAmount' },
      {
         id: 'pendingAmount',
         header: 'Pending Amount',
         accessor: 'pendingAmount',
      },
      { id: 'createdu', header: 'Created By', accessor: 'createdu' },
      { id: 'updatedu', header: 'Updated By', accessor: 'updatedu' },
      { id: 'status', header: 'STATUS', accessor: 'status' },
   ];

   const [columnVisibility, setColumnVisibility] = React.useState(
      columnsData.reduce((acc, column) => {
         acc[column.id] = true;
         if (column.id === 'qty1') acc[column.id] = false;
         if (column.id === 'qty2') acc[column.id] = false;
         if (column.id === 'qty3') acc[column.id] = false;
         return acc;
      }, {}),
   );

   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

   const columns = columnsData
      .filter((column) => columnVisibility[column.id])
      .map((column) =>
         columnHelper.accessor(column.id, {
            id: column.id,
            header: () => (
               <Text
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color="gray.400">
                  {column.header}
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
      );

   columns.push(
      columnHelper.accessor('id', {
         id: 'id',
         header: () => null,
         cell: (info) => (
            <Flex justify="end">
               <Box className="edit-icon-container">
                  <IconButton
                     aria-label="Edit"
                     icon={<EditIcon />}
                     variant="ghost"
                     colorScheme="brand"
                     // onClick={() => handleEditClick(info.row)}
                     onClick={() => navigate('/admin/sales/invoice/edit/' + info.row.id)}
                  // onClick={() => {
                  //   // Create a new object with spread to ensure a fresh reference
                  //   setCurrentRow({ ...info.row });
                  //   setIsEditMode(true);
                  //   onOpen();
                  // }}
                  />
                  <IconButton
                     aria-label="Delete"
                     icon={<DeleteIcon />}
                     variant="ghost"
                     colorScheme="red"
                     onClick={(e) => {
                        e.stopPropagation(); // Prevent the table row click event from being triggered
                        handleDeleteClick(info.row.id);
                        setIsOpenSingleView(false);
                     }}
                  />
               </Box>
            </Flex>
         ),
      }),
   );

   const table = useReactTable({
      data,
      columns,
      state: { sorting },
      onSortingChange: setSorting,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   const handleSave = (formData) => {
      if (isEditMode && currentRow) {
         setData(data.map((row) => (row.id === currentRow.id ? { ...currentRow, ...formData } : row)));
      } else if (!isEditMode) {
         setData([...data, { ...formData, id: Date.now() }]);
      }
      onClose();
   };

   const [dynamicUserDetails, setDynamicUserDetails] = useState([]);
   const account = useSelector((state) => state.account.single);

   useEffect(() => {
      if (account) {
         const details = [
            { label: 'Bill To', value: account?.name || '-' },
            { label: 'Mobile', value: account?.mobile || '-' },
            { label: 'PAN', value: account?.panNo || '-' },
            { label: 'Billing Address', value: account?.address || '-' },
         ];
         setDynamicUserDetails(details);
      }
   }, [account]);

   const handleViewSingleData = async (id) => {
      if (id) dispatch(getSingleSaleInvoice(id));
      const accountbyid = {
         id: Number(singleEntity.accountId), // id must be number
         compId: String(user?.loginhistory?.companyId), // compId must be string
      };
      if (singleEntity && singleEntity.accountId) dispatch(getAccountById(accountbyid));
      setIsOpenSingleView(true);
   };

   // --------------------- filter --------------------- //
   const backgroundColor = useColorModeValue('white', '#101F4A');

   const [selectedFilter, setSelectedFilter] = useState(''); // Stores selected filter type
   const [DOCNOselectedFilter, setDOCNOselectedFilter] = useState(''); // Stores input value
   const [BillDateselectedFilter, setBillDateselectedFilter] = useState('');
   const [DaybookselectedFilter, setDaybookselectedFilter] = useState('');
   const [PartyselectedFilter, setPartyselectedFilter] = useState('');
   const [TaxableAmountselectedFilter, setTaxableAmountselectedFilter] = useState('');
   const [GSTselectedFilter, setGSTselectedFilter] = useState('');
   const [NetAmountselectedFilter, setNetAmountselectedFilter] = useState('');
   const [PendingAmountselectedFilter, setPendingAmountselectedFilter] = useState('');
   const [CreatedByselectedFilter, setCreatedByselectedFilter] = useState('');
   const [UpdatedByselectedFilter, setUpdatedByselectedFilter] = useState('');

   const [inputValue, setInputValue] = useState('');
   const [DOCNOInputValue, setDOCNOInputValue] = useState(''); // Stores input value
   const [BillDateInputValue, setBillDateInputValue] = useState('');
   const [DaybookInputValue, setDaybookInputValue] = useState('');
   const [PartyInputValue, setPartyInputValue] = useState('');
   const [TaxableAmountInputValue, setTaxableAmountInputValue] = useState('');
   const [GSTInputValue, setGSTInputValue] = useState('');
   const [NetAmountInputValue, setNetAmountInputValue] = useState('');
   const [PendingAmountinputValue, setPendingAmountInputValue] = useState('');
   const [CreatedByInputValue, setCreatedByInputValue] = useState('');
   const [UpdatedByInputValue, setUpdatedByInputValue] = useState('');
   const [STATUSInputValue, setSTATUSInputValue] = useState('');
   const [addedName, setAddedName] = useState(''); // Stores final displayed value

   const [SalesInvoiceData, setSalesInvoiceData] = useState([]);

   useEffect(() => {
      const fetchData = async () => {
         try {
            if (user && user?.loginhistory?.companyId) {
               let fetchParams = {
                  companyId: user?.loginhistory?.companyId,
               }; // Default fetchParams
               let filters = []; // Array to hold filter objects

               if (DOCNOInputValue && DOCNOselectedFilter) {
                  filters.push({ 'doc no': { value: DOCNOInputValue, type: DOCNOselectedFilter } });
               }
               if (BillDateInputValue && BillDateselectedFilter) {
                  filters.push({ 'bill date': { value: BillDateInputValue, type: BillDateselectedFilter } });
               }
               if (DaybookInputValue && DaybookselectedFilter) {
                  filters.push({ daybook: { value: DaybookInputValue, type: DaybookselectedFilter } });
               }
               if (PartyInputValue && PartyselectedFilter) {
                  filters.push({ party: { value: PartyInputValue, type: PartyselectedFilter } });
               }
               if (TaxableAmountInputValue && TaxableAmountselectedFilter) {
                  filters.push({
                     'taxable amount': { value: TaxableAmountInputValue, type: TaxableAmountselectedFilter },
                  });
               }
               if (GSTInputValue && GSTselectedFilter) {
                  filters.push({ gst: { value: GSTInputValue, type: GSTselectedFilter } });
               }
               if (NetAmountInputValue && NetAmountselectedFilter) {
                  filters.push({ 'net amount': { value: NetAmountInputValue, type: NetAmountselectedFilter } });
               }
               if (PendingAmountinputValue && PendingAmountselectedFilter) {
                  filters.push({
                     'pending amount': { value: PendingAmountinputValue, type: PendingAmountselectedFilter },
                  });
               }
               if (CreatedByInputValue && CreatedByselectedFilter) {
                  filters.push({ 'created by': { value: CreatedByInputValue, type: CreatedByselectedFilter } });
               }
               if (UpdatedByInputValue && UpdatedByselectedFilter) {
                  filters.push({ 'updated by': { value: UpdatedByInputValue, type: UpdatedByselectedFilter } });
               }
               const response = await dispatch(getSaleInvoices(fetchParams));

               // Check if response is an array
               if (response.length > 0 && Array.isArray(response)) {
                  setSalesInvoiceData(response);
               } else {
                  setSalesInvoiceData([]); // ✅ Prevents 'undefined' error
               }
            }
         } catch (error) {
            setSalesInvoiceData([]); // ✅ Ensure an empty array is set
         }
      };
      fetchData();
   }, [
      dispatch,
      DOCNOInputValue,
      BillDateInputValue,
      DaybookInputValue,
      PartyInputValue,
      TaxableAmountInputValue,
      GSTInputValue,
      NetAmountInputValue,
      PendingAmountinputValue,
      CreatedByInputValue,
      UpdatedByInputValue,
      STATUSInputValue,
      user,
   ]);

   useEffect(() => {
      setData([...salesInvoiceData]);
   }, [salesInvoiceData]);

   const [isDropdownOpen, setDropdownOpen] = useState(false);

   const toggleDropdown = () => {
      setDropdownOpen(!isDropdownOpen);
   };

   const [selectedColumn, setSelectedColumn] = useState(null);

   const handleImageClick = (columnHeader) => {
      setSelectedColumn(columnHeader); // Store which column was clicked
      setDropdownOpen(true);
      if (selectedColumn?.props?.children === 'DOC NO') {
         setInputValue(DOCNOInputValue);
      } else if (selectedColumn?.props?.children === 'Bill Date') {
         setInputValue(BillDateInputValue);
      } else if (selectedColumn?.props?.children === 'Daybook') {
         setInputValue(DaybookInputValue);
      } else if (selectedColumn?.props?.children === 'Party') {
         setInputValue(PartyInputValue);
      } else if (selectedColumn?.props?.children === 'Taxable Amount') {
         setInputValue(TaxableAmountInputValue);
      } else if (selectedColumn?.props?.children === 'GST') {
         setInputValue(GSTInputValue);
      } else if (selectedColumn?.props?.children === 'Net Amount') {
         setInputValue(NetAmountInputValue);
      } else if (selectedColumn?.props?.children === 'Pending Amount') {
         setInputValue(PendingAmountinputValue);
      } else if (selectedColumn?.props?.children === 'Created By') {
         setInputValue(CreatedByInputValue);
      } else if (selectedColumn?.props?.children === 'Updated By') {
         setInputValue(UpdatedByInputValue);
      }
   };

   const handleFilterClick = () => {
      const selectedKey = selectedColumn?.props?.children;

      const inputSetters = {
         'DOC NO': setDOCNOInputValue,
         'Bill Date': setBillDateInputValue,
         Daybook: setDaybookInputValue,
         Party: setPartyInputValue,
         'Taxable Amount': setTaxableAmountInputValue,
         GST: setGSTInputValue,
         'Net Amount': setNetAmountInputValue,
         'Pending Amount': setPendingAmountInputValue,
         'Created By': setCreatedByInputValue,
         'Updated By': setUpdatedByInputValue,
         STATUS: setSTATUSInputValue,
      };

      const selectedoption = {
         'DOC NO': setDOCNOselectedFilter,
         'Bill Date': setBillDateselectedFilter,
         Daybook: setDaybookselectedFilter,
         Party: setPartyselectedFilter,
         'Taxable Amount': setTaxableAmountselectedFilter,
         GST: setGSTselectedFilter,
         'Net Amount': setNetAmountselectedFilter,
         'Pending Amount': setPendingAmountselectedFilter,
         'Created By': setCreatedByselectedFilter,
         'Updated By': setUpdatedByselectedFilter,
      };

      if (selectedKey && inputSetters[selectedKey]) {
         inputSetters[selectedKey](inputValue); // Assign value only on button click
      } else {
         setSTATUSInputValue(inputValue); // Default case
      }

      if (selectedKey && selectedoption[selectedKey]) {
         selectedoption[selectedKey](selectedFilter); // Assign value only on button click
      }

      setDropdownOpen(false);
   };

   const handlecancelClick = () => {
      if (selectedColumn?.props?.children === 'DOC NO') {
         setDOCNOInputValue('');
      } else if (selectedColumn?.props?.children === 'Bill Date') {
         setBillDateInputValue('');
      } else if (selectedColumn?.props?.children === 'Daybook') {
         setDaybookInputValue('');
      } else if (selectedColumn?.props?.children === 'Party') {
         setPartyInputValue('');
      } else if (selectedColumn?.props?.children === 'Taxable Amount') {
         setTaxableAmountInputValue('');
      } else if (selectedColumn?.props?.children === 'GST') {
         setGSTInputValue('');
      } else if (selectedColumn?.props?.children === 'Net Amount') {
         setNetAmountInputValue('');
      } else if (selectedColumn?.props?.children === 'Pending Amount') {
         setPendingAmountInputValue('');
      } else if (selectedColumn?.props?.children === 'Created By') {
         setCreatedByInputValue('');
      } else if (selectedColumn?.props?.children === 'Updated By') {
         setUpdatedByInputValue('');
      }
      setDropdownOpen(false);
   };

   const getLeftValue = (column) => {
      switch (column) {
         case 'DOC NO':
         case 'Bill Date':
         case 'Party':
         case 'Daybook':
            return '0%';
         case 'Taxable Amount':
         case 'GST':
         case 'Net Amount':
            return '40%';
         default:
            return '60%';
      }
   };

   const handleOnClose = useCallback(() => {
      dispatch(emptySales());
      setIsOpenSingleView(false);
   }, []);

   // const [expanded, setExpanded] = useState(false);
   // const wrapperRef = useRef();
   // useOutsideClick({
   //    ref: wrapperRef,
   //    handler: () => {
   //       if (searchQuery === '') setExpanded(false);
   //    },
   // });

   return (
      <Card
         flexDirection="column"
         w="100%"
         px="0px"
         overflowX={{ sm: 'scroll', lg: 'hidden' }}
         position="relative"
         py="10px">
         <Flex px="25px" mb="8px" justifyContent="space-between" align="center" overflowX="auto">
            <Flex align="center" gap={10}>
               <Text color={textColor} fontSize={{ base: '17px', lg: '22px' }} fontWeight="700" lineHeight="100%">
                  Sale Invoice
               </Text>
               <Button
                  onClick={() => {
                     // setCurrentRow({});
                     // setIsEditMode(false);
                     // onOpen();
                     navigate('/admin/sales/invoice/add');
                  }}
                  variant="darkBrand"
                  color="white"
                  fontSize="sm"
                  fontWeight="500"
                  borderRadius="full"
                  p={{ base: '4', lg: '5' }}>
                  Add New
               </Button>
            </Flex>
            <Flex>
               <Flex justify="space-between" mb="8px">
                  <Flex align="center">
                     <Button onClick={() => handlePageChange('prev')} isDisabled={!pagination?.hasPreviousPage}>
                        <MdNavigateBefore size={28} />
                     </Button>
                     <Text mx="10px" fontSize={{ base: '14px', lg: '17px' }}>
                        {pagination?.currentPage || 1} / {pagination?.totalPages || 1}
                     </Text>
                     <Button onClick={() => handlePageChange('next')} isDisabled={!pagination?.hasNextPage}>
                        <MdNavigateNext size={28} />
                     </Button>
                  </Flex>
               </Flex>
               <Select
                  width="auto"
                  marginRight={5}
                  value={limit === pagination?.totalProducts ? 'ALL' : limit.toString()}
                  onChange={handlePageSizeChange}>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="ALL">All</option>
               </Select>
               <SearchBar
                  mb={() => {
                     return 'unset';
                  }}
                  value={searchQuery}
                  onChange={(e) => {
                     setSearchQuery(e.target.value);
                     resetPage();
                  }}
                  me="10px"
                  borderRadius="30px"
               />
               {/* <MotionFlex
                  ref={wrapperRef}
                  align="center"
                  bg={bg}
                  borderRadius="full"
                  me="20px"
                  cursor="pointer"
                  px={expanded ? 3 : 0}
                  w={expanded ? '200px' : '40px'}
                  h="40px"
                  transition="all 0.3s ease"
                  onClick={() => setExpanded(true)}
               >
                  <MotionSearchIcon
                     color={icon}
                     animate={{ rotate: expanded ? 0 : 90 }}
                     transition={{ duration: 0.3 }}
                     style={{ marginRight: expanded ? '8px' : '10px', marginLeft: expanded ? '0' : '10px'}}
                  />
                  {expanded && (
                     <Input
                        variant="unstyled"
                        // fontSize={15}
                        placeholder="Search..."
                        value={searchQuery}
                        color={icon}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        autoFocus
                     />
                  )}
               </MotionFlex> */}
               <Menu
                  onDownloadPDF={downloadPDF}
                  onDownloadExcel={downloadExcel}
                  columnVisibility={columnVisibility}
                  setColumnVisibility={setColumnVisibility}
               />
               {/* <Button
            onClick={() => {
              // setCurrentRow({});
              // setIsEditMode(false);
              // onOpen();
              navigate('/admin/sales/invoice/add');
            }}
            variant="darkBrand"
            color="white"
            fontSize="sm"
            fontWeight="500"
            borderRadius="full"
            position="fixed"
            bottom="20px"
            right="20px"
            p={6}
            zIndex={100}
          >
            Add New
          </Button> */}
            </Flex>
         </Flex>

         {/* Table Rendering */}
         <Box
            overflowX="auto"
            className="custom-scrollbar"
            position="relative"
            minH={{ base: '75vh', lg: '75vh', xl: '75vh' }}
            maxH={{ base: '75vh', lg: '75vh', xl: '75vh' }}
            borderTop="1px solid #ccc">
            <Table variant="simple" color="gray.500" mb="24px" mt="12px">
               <Thead position="sticky" top={-1} zIndex={1} bg={backgroundColor}>
                  {table.getHeaderGroups().map((headerGroup) => (
                     <Tr key={headerGroup.id}>
                        {headerGroup.headers.map((header) => (
                           <Th
                              // borderTop="1px solid"
                              key={header.id}
                              colSpan={header.colSpan}
                              pe="10px"
                              borderColor={borderColor}
                              cursor="pointer"
                           // onClick={header.column.getToggleSortingHandler()}
                           >
                              <Flex
                                 // justifyContent="space-between"
                                 align="center"
                                 fontSize={{ sm: '10px', lg: '12px' }}
                                 color="gray.400"
                                 id={header.column.columnDef.header}>
                                 {header.id !== 'id' && header.id !== 'status' && (
                                    <img
                                       src={filter}
                                       alt="Filter"
                                       width="12px"
                                       height="12px"
                                       style={{ marginRight: '10px', cursor: 'pointer' }}
                                       id={header.column.columnDef.header}
                                       onClick={() => {
                                          handleImageClick(header.column.columnDef.header); // Pass column header
                                          toggleDropdown(); // Open/close dropdown
                                       }}
                                    />
                                 )}
                                 <div style={{ marginRight: '10px' }}>
                                    {flexRender(header.column.columnDef.header, header.getContext())}
                                 </div>
                                 {{
                                    asc: '↑',
                                    desc: '↓',
                                 }[header.column.getIsSorted()] ?? null}
                              </Flex>
                           </Th>
                        ))}
                     </Tr>
                  ))}
               </Thead>
               <Tbody>
                  {/* Dropdown Box (Sliding Effect) */}
                  {isDropdownOpen && selectedColumn?.props?.children && (
                     <Box
                        position="absolute"
                        top="130px" // Dropdown below image
                        left={getLeftValue(selectedColumn?.props?.children)}
                        width="auto"
                        bg={backgroundColor}
                        border="1px solid gray"
                        borderRadius="5px"
                        boxShadow="md"
                        p="2"
                        mt="2"
                        zIndex="10"
                        transition="all 0.2s ease-in-out">
                        <Grid templateColumns="repeat(1, 1fr)" gap={4} p={4}>
                           <Grid justifyContent="center" color={textColor} fontSize="2xl" fontWeight="medium">
                              <label>Select {selectedColumn.props.children.toLowerCase()} Filter</label>
                           </Grid>
                           <hr></hr>
                           {/* Label and Dropdown */}
                           <GridItem display="flex" alignItems="center">
                              <FormLabel htmlFor="dropdown" width="60%" color={textColor}>
                                 Select option
                              </FormLabel>
                              <Select
                                 id="dropdown"
                                 placeholder="Choose an option"
                                 color={textColor}
                                 onChange={(e) => setSelectedFilter(e.target.value)} // Update selected filter
                              >
                                 <option value="1">Starts With</option>
                                 <option value="2">Ends With</option>
                                 <option value="3">Contains</option>
                                 <option value="4">Equal</option>
                                 <option value="5">Empty</option>
                                 <option value="6">Does Not Start With</option>
                                 <option value="7">Does Not End With</option>
                                 <option value="8">Does Not Contain</option>
                                 <option value="9">Not Equal</option>
                                 <option value="10">Not Empty</option>
                                 <option value="11">Like</option>
                              </Select>
                           </GridItem>

                           {/* Second Label and Input Box */}
                           <GridItem display="flex" alignItems="center">
                              <FormLabel htmlFor="input1" width="60%" color={textColor}>
                                 Enter the value
                              </FormLabel>
                              <Input
                                 id="input2"
                                 color={textColor}
                                 placeholder="Enter last name"
                                 value={inputValue}
                                 onChange={(e) => setInputValue(e.target.value)}
                              />
                           </GridItem>

                           {/* Button */}
                           <GridItem mt="20px" display="flex" justifyContent="space-between">
                              <Button colorScheme="blue" width="45%" onClick={handleFilterClick}>
                                 Filter
                              </Button>
                              <Button colorScheme="red" width="45%" onClick={handlecancelClick}>
                                 cancel
                              </Button>
                           </GridItem>
                        </Grid>
                     </Box>
                  )}
                  {isLoading ? (
                     <>
                        <Tr>
                           <Td colSpan={table.getAllColumns().length} p={6}>
                              <Loading />
                           </Td>
                        </Tr>
                     </>
                  ) : (
                     <>
                        {salesInvoiceData.length === 0 ? (
                           <Tr justifyContent="center" alignItems="center" width="100%" height="100%">
                              <Td colSpan={columns.length} justifyContent="center" alignItems="center" width="100%">
                                 <Grid justifyContent="center" alignItems="center" gap={9}>
                                    <img
                                       src={nodata} // Replace with actual image URL
                                       alt="No Data Found"
                                       width="200px"
                                       height="200px"
                                    />
                                    <GridItem justifySelf="center">
                                       <label>No sales invoice data found</label>
                                    </GridItem>
                                 </Grid>
                              </Td>
                           </Tr>
                        ) : (
                           // Render data rows if available
                           salesInvoiceData
                              .filter((item) => item.id !== undefined)
                              .map((row) => (
                                 <Tr
                                    key={row.id}
                                    className="editable-row"
                                    _hover={{
                                       bg: 'rgba(0, 63, 140, 0.08)',
                                       cursor: 'pointer',
                                    }}
                                    onClick={(e) => {
                                       if (e.target.tagName !== 'BUTTON') {
                                          handleViewSingleData(row.id);
                                       }
                                    }}>
                                    {columns.map((column) => (
                                       <Td
                                          key={column.id}
                                          fontSize={{ sm: '14px' }}
                                          minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                                          // borderColor="transparent"
                                          borderColor="gray.200">
                                          {flexRender(column.cell, {
                                             row,
                                             getValue: () => {
                                                if (column.id === 'transactionAt')
                                                   return moment(row.transactionAt).format('DD/MM/YYYY');
                                                if (column.id === 'qty1')
                                                   return row?.lineitems?.reduce(
                                                      (acc, item) => acc + Number(item.qty1),
                                                      0,
                                                   );

                                                if (column.id === 'qty2')
                                                   return row?.lineitems?.reduce(
                                                      (acc, item) => acc + Number(item.qty2),
                                                      0,
                                                   );

                                                if (column.id === 'qty3')
                                                   return row?.lineitems?.reduce(
                                                      (acc, item) => acc + Number(item.qty3),
                                                      0,
                                                   );
                                                if (column.id === 'taxableAmount')
                                                   return row?.lineitems?.reduce(
                                                      (acc, item) => acc + Number(item.taxableAmount),
                                                      0,
                                                   );
                                                if (column.id === 'gst')
                                                   return row?.lineitems?.reduce(
                                                      (acc, item) => acc + Number(item.netGst),
                                                      0,
                                                   );
                                                return row[column.id];
                                             },
                                          })}
                                       </Td>
                                    ))}
                                 </Tr>
                              ))
                        )}
                     </>
                  )}
               </Tbody>
            </Table>
         </Box>

         {/* Pagination Controls */}
         {/* <Flex justify="space-between" px="25px" mb="8px">
        <Flex align="center">
          <Button
            onClick={() => handlePageChange("prev")}
            isDisabled={!pagination?.hasPreviousPage}
          >
            Previous
          </Button>
          <Text mx="10px">
            Page {pagination?.currentPage || 1} of {pagination?.totalPages || 1}
          </Text>
          <Button
            onClick={() => handlePageChange("next")}
            isDisabled={!pagination?.hasNextPage}
          >
            Next
          </Button>
        </Flex>
      </Flex> */}

         <style jsx>{`
            .editable-row {
               position: relative;
               background: ${useColorModeValue('white', 'gray.700')};
               transition: background 0.3s ease;
            }

            .editable-row:hover {
               background: ${useColorModeValue('gray.100', 'gray.600')};
            }

            .editable-row .edit-icon-container {
               display: none;
            }

            .editable-row:hover .edit-icon-container {
               display: block;
               position: absolute;
               right: 10px;
               top: 50%;
               transform: translateY(-50%);
            }
         `}</style>
         <DeleteDialog
            isDeleteDialogOpen={isDeleteDialogOpen}
            setDeleteDialogOpen={setDeleteDialogOpen}
            handleDelete={handleDelete}
            title="Sale Invoice"
         />
         <SalesSingleDataView
            isOpenSingleView={isOpenSingleView}
            onClose={handleOnClose}
            entityType="saleinvoice"
            singleEntity={singleEntity}
            dynamicUserDetails={dynamicUserDetails}
            // initialIndex={initialIndex}
            // invoices={invoices}
            onEditFormClose={() => setIsOpenSingleView(true)}
            setIsOpenSingleView={setIsOpenSingleView}
            isEditFormOpen={isEditFormOpen}
            setIsEditFormOpen={setIsEditFormOpen}
         />
      </Card>
   );
}
